import { ChamKetNoi } from './KetNoi';
import logo from './logo.png';
import type { NguoiDung } from './kieu';

const TEN_VAI: Record<NguoiDung['vaiTro'], string> = {
  SELLER: 'Tư vấn',
  CASHIER: 'Thu ngân',
  ADMIN: 'Quản lý',
  WAREHOUSER: 'Kho',
};

/**
 * Thanh trên — một thanh NỔI, không phải một dải có đường kẻ dưới.
 *
 * 🔴 Thanh này dùng chung cho CẢ BA giao diện, mà màn tư vấn chạy trên ĐIỆN
 *    THOẠI. Nên mọi thứ ở đây phải co được:
 *
 *      · `flexShrink: 0` cho thứ KHÔNG được co (logo, chấm kết nối, nút Thoát)
 *      · `minWidth: 0` cho thứ ĐƯỢC co — thiếu nó thì flex không cho con co
 *        xuống dưới kích thước nội dung, và chữ xuống dòng thay vì cắt bớt
 *      · tên người dùng một dòng, cắt bằng ba chấm
 *
 *    Luật cho màn hẹp nằm ở cuối `nen.css` (media query), không nằm ở đây —
 *    style inline không viết được `@media`.
 */
export function ThanhTren({
  nguoiDung,
  thoat,
  giua,
}: {
  nguoiDung: NguoiDung;
  thoat: () => void;
  giua?: React.ReactNode;
}) {
  return (
    <header
      className="noi troi-len thanh-tren"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 22,
        padding: '13px 22px',
        flexShrink: 0,
        flexWrap: 'nowrap',
        position: 'relative',
        zIndex: 2,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
        {/*
          Logo thương hiệu. Đặt CẢ `height` LẪN `width`: trình duyệt biết trước
          chỗ cần chừa nên thanh trên không giật một nhịp lúc ảnh tải xong.
          64 = 30 × 2.1314 (tỉ lệ thật của file gốc 1411×662) — sai tỉ lệ ở đây
          là logo bị bóp, mà bóp logo thương hiệu thì khách nhìn ra ngay.
        */}
        <img
          src={logo}
          alt="Color District"
          width={64}
          height={30}
          style={{ display: 'block', flexShrink: 0 }}
        />
        <span className="the the-mo an-khi-hep">{TEN_VAI[nguoiDung.vaiTro]}</span>
      </div>

      {/* Chỗ trống co giãn. Màn tư vấn không truyền gì vào đây, nên nó chỉ là
          khoảng đệm đẩy khối người dùng sang phải. */}
      <div style={{ flex: 1, minWidth: 0 }}>{giua}</div>

      <ChamKetNoi />

      {/* Tên người dùng nằm trong một giếng lõm — nó là thông tin, không phải
          thứ bấm được. Nút Thoát bên cạnh thì nổi, vì nó bấm được. */}
      <div
        className="lom-nho khoi-nguoi"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 14,
          padding: '7px 8px 7px 16px',
          borderRadius: 'var(--tron)',
          minWidth: 0,
        }}
      >
        <div style={{ textAlign: 'right', lineHeight: 1.3, minWidth: 0 }}>
          <div className="ten-mot-dong ten-nguoi" style={{ fontSize: 13, fontWeight: 600 }}>
            {nguoiDung.hoTen}
          </div>
          <div
            className="ten-mot-dong an-khi-hep"
            style={{ fontSize: 11, color: 'var(--chu-3)' }}
          >
            {nguoiDung.username}
          </div>
        </div>
        <button
          onClick={thoat}
          style={{
            padding: '8px 15px',
            fontSize: 13,
            borderRadius: 'var(--tron)',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          Thoát
        </button>
      </div>
    </header>
  );
}
